import { useMutation } from '@tanstack/react-query';
import { PolicyInsight } from '../../../../types/policies';
import { apiPost } from '../../../../api';

interface Response {
    insightId: PolicyInsight['policyId'];
}

interface ErrorResponse {
    error: string;
}

type UseUnresolveInsightParams = {
    onSuccess?: (response: Response) => void;
    onError?: (errorResponse: ErrorResponse) => void;
};

const unresolveInsight = (insightId: PolicyInsight['id']) => {
    return apiPost<never, Response>(`/policies/insights/${insightId}/unresolve`);
};

export const useUnresolveInsight = ({ onSuccess, onError }: UseUnresolveInsightParams) => {
    return useMutation({
        mutationFn: unresolveInsight,
        onSuccess,
        onError
    });
};
